import { createContext } from 'react';

const CampaignUTMTrackingContext = createContext();

export default CampaignUTMTrackingContext;